var Manufacturers ;
Manufacturers = $.extend({}, BaseModule ,{

    api_route : 'manufacturers',
	
	data : {
        module          : 'manufacturers',
        page            : 1,
        limit           : 42,
        order_by         : 'name:asc',
        with            : 'file:categories',
        details_with    : 'file:categories:users',
        view            : 'grid',
        'with-products' : 1,
        pagination      : true
    },
    
    save_order:function(){
        var module_name = this.data.module;
        var module = this;

        var selection = [];
        $('input[name="order_item_id[]"]').each(function(){
            selection.push($(this).val());
        });

        $.ajax({
            url : API + module.api_route + '/order',
            method:'POST',
            data:{ 
                category_id:$('#'+module_name+'-dialog-list  select[name="category_id"]').val(),
                order_item_id: selection 
            },
            success:function(data){
                $("#"+module_name+"-dialog-list").modal('hide');
            }
        });
        return false;
    },

    title_formula:function(){

        var module_name = this.data.module, module = this;
        var t = [];
        $('.details-container[data-target="'+module_name+'"] form  select[name="product_title_formula[]"]').each(function(){
            t.push($(this).find('option:selected').attr('rel'));
        });

        return t.join(' ');
    },

    after_load_entry:function(){
        "use strict";
        var module_name = this.data.module,module = this;
        module.save();
        $('.details-container[data-target="'+module_name+'"] form select[name="product_title_formula[]"]').on('change',function(){
            module.title_formula();
        });

        $('.details-container[data-target="'+module_name+'"] form .sample').text(module.title_formula());
        $('#manufacturers_form .update-map').click(function () {
            var address = $('input[name="address"]').val() + ' '+$('input[name="address_2"]').val() + ' '+$('input[name="state"]').val() + ' '+$('input[name="zip"]').val();
            module.geocode(address);
            return false;

        });

        if($('#manufacturers_form input[name="latitude"]')){
            module.init_map($('#manufacturers_form input[name="lat"]').val(), $('#manufacturers_form input[name="lng"]').val());
        }
    },

    init_map : function(lat,lng){

        $('#manufacturers_form input[name="latitude"]').removeClass('empty').val(lat);
        $('#manufacturers_form input[name="longitude"]').removeClass('empty').val(lng);

        var latLng = new google.maps.LatLng(lat, lng);
        var map = new google.maps.Map(document.getElementById('mapCanvas'), {
            zoom: 17,
            center: latLng,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        var marker = new google.maps.Marker({
            position: latLng,
            title: 'Location',
            map: map,
            draggable: true
        });

        google.maps.event.addListener(marker, 'dragend', function () {
            var newPosition = marker.getPosition();
            $('#manufacturers_form input[name="lat"]').val(newPosition.lat());
            $('#manufacturers_form input[name="lng"]').val(newPosition.lng());
            $('#manufacturers_form .update-map span').html('Reset Map');
        });
    },

    geocode : function(address){
        var module  = this;
        var geocoder = new google.maps.Geocoder();
        address = address.replace(/\n/g, ',').replace(/\s/g, ' ').replace(/  ,/g, ',');

        geocoder.geocode({
            'address': address}, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var lat = results[0].geometry.location.lat();
                var lng = results[0].geometry.location.lng();

                module.init_map(lat, lng);

            } else {
                alert("We couldn't find a valid Location based on the given address");
            }
        });

    },


    init:function(){
        "use strict";
        var module_name = this.data.module,
            module = this;

        $(document).on('change','.details-container[data-target="'+module_name+'"] form  select[name="product_title_formula[]"]',function(){
            $('.details-container[data-target="'+module_name+'"] form .sample').text(module.title_formula());
        });
    }

});

$(document).ready(function(){
    "use strict";
    Manufacturers.init();
});
